import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoWhatInBox from 'eco-design/sections/eco-what-in-box';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.WhatInBoxA');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770763562/45.png',
            title: t('item1_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770344424/EcoFlow%20AC%20Power%20Adapter.png',
            title: t('item2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770344080/Basket.png',
            title: t('item3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770344227/EcoFlow%20Car%20Charging%20Cable.png',
            title: t('item4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770344605/Temperature%20zone%20divider%20(for%2045L%20and%2055L).png',
            title: t('item5_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744770344841/Safety%20Instructions%2C%20Quick%20Start%20Guide%2C%20Warranty%20Card.png',
            title: t('item6_title'),
        },
    ];

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <EcoWhatInBox items={itemsA} />
        </div>
    );
}
